<template>
  <div>
    <div class="d-flex justify-space-around">
      <v-text-field class="input-text-size mr-3"
       :value="editedItemTwo.payment" label="Payment #" readonly tabindex="-1" />
      <v-text-field class="input-text-size mr-3"
       :value="toShortDate(editedItemTwo.paymentDate)" label="Date"
        readonly tabindex="-1" />
      <v-text-field class="input-text-size mr-3"
       :value="editedItemTwo.workstation" label="Workstation #" readonly tabindex="-1" />
      <v-text-field class="input-text-size mr-3"
       :value="editedItemTwo.username" label="User" readonly tabindex="-1" />
      <v-checkbox class="input-text-size mr-3 mt-4" label="MAIL"
       :input-value="editedItemTwo.mail" disabled hide-details />
      <v-btn class="input-text-size pa-5 mt-3" :disabled="reverseEntriesDisableFunc()"
       @click="reverseEntriesCliked()" small color="primary">
        Reverse Entire <br />Payment
      </v-btn>
    </div>
    <v-alert v-if="isPartialTaxDetailView" type="info" dense text
     class="input-text-size mb-1 partial-tax-detail-alert">
      Showing only the tax record open on this screen. This payment paid
      {{ editedItemTwo.taxDetailsCount }} tax records. The payment amounts below are for the
      entire transaction, not just this tax record.
    </v-alert>
    <CRUDList ref="crudList" noResultOverride="No payments found"
     :canAdd="false" :canEdit="false" :canSave="false" :showSelect="false"
     :displayTopPagination="false" :hideDefaultFooter="true"
     :enableFixedHeaders="true" :disableKeyboardFunc="false"
     :headers="taxDetHeaders" :baseCrudKey="taxDetBaseCrudKey"
     tableWrapperDynamicClassname='taxroll-table-wrapper-two' tableDynamicHeight="190"
    :defaultSortBy="defaultSortBy" />
    <v-data-table dense :headers="taxPayHeaders"
     class="elevation-1 input-text-size mt-5" :items="editedItem"
      item-key="key" hide-default-footer disable-pagination>
      <template v-slot:item="{ item }">
        <tr>
          <td>
            <v-text-field :value="item.paymentType" hide-details dense flat solo readonly tabindex="-1" />
          </td>
          <td>
            <v-text-field :value="item.checkNumber" hide-details dense flat solo readonly tabindex="-1" />
          </td>
          <td>
            <v-text-field :value="item.creditType" hide-details dense flat solo readonly tabindex="-1" />
          </td>
          <td>
            <v-text-field :value="amountFormat(item.amount)"
             hide-details dense flat solo readonly tabindex="-1" />
          </td>
          <td style="width: 35%;">
            <v-text-field v-model="item.paidBy" hide-details dense flat solo
            @blur="somethingChanged()" />
          </td>
        </tr>
      </template>
    </v-data-table>
    <CRUDDialog
      :baseCrudKey='reverseEntriesCrudKey'
      :canSave="false"
      onlyDialogHeaderName="Payment Reversal Details"
      dialogDynamicWidth='350' @crudDialogClose="onClose">
    <template v-slot:[`editedItem`]="{}">
      <v-text-field v-model.number="revEntriesObj.workstation" class="input-text-size"
      label="Payment Reversal Wkst" />
      <ClarionDateControl class="input-text-size" label="Reversal Date"
      :isToggle="false" v-model="revEntriesObj.payDate" />
      <CommonDropDowns class="mt-n3 mr-1" :isItTaxFee=true
      @change="dataFromCommonDropDowns" :taxFeeNumValue="revEntriesObj.feeNumber"
      taxFeeLabelOverride="Insufficient Check Fee #" taxFeeNameOverride="feeNumber" />
      <v-text-field v-model="revEntriesObj.feeAmount" class="input-text-size"
      label="Fee Amount" @blur="roundAmount" :readonly="editedItem.isPaid"
      :tabindex="editedItem.isPaid ? -1 : 0"
      @focus="amountToNum(), $event.target.select()" />
      <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
      v-model="revEntriesObj.applyFees" label="Apply Fee" @change="onApplyFeeCheckBoxClick" />
    </template>
      <template v-slot:[`additionalActions`]="{}">
      <v-btn class="input-text-size" :disabled="disableConfirm"
        @click="onConfirmClicked()" text color="blue darken-1">
        Confirm
      </v-btn>
      </template>
    </CRUDDialog>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations, mapActions,
  mapState,
} from 'vuex';
import { taxDetailsPaymentsHeaders, taxPaymPaymentsHeaders } from '../../TaxInquiryUtils/TableHeaders.utils';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { amountFormat, amountToNumber } from '../../../../../util/shared/vue-global';
import { toIsoDate, toShortDate } from '../../../../../util/shared/tmc-global';
import CRUDDialog from '../../../../common/base/crud-2.0/CRUDDialog.vue';
import { getWorkstationNumber } from '../../../../../util/workstation-util';
import ClarionDateControl from '../../../../common/ClarionDateControl.vue';
import CommonDropDowns from '../../../common-utils/CommonDropDowns.mixin.vue';
import { taxCommonPostProcessTrans, taxFeesPostProcessTrans, taxPostProcessFeesList } from '../../../common-utils/CommonTaxFunctionalities';

export default {
  name: 'TaxRollPaymentsDialog',
  data() {
    return {
      taxDetHeaders: taxDetailsPaymentsHeaders,
      taxPayHeaders: taxPaymPaymentsHeaders,
      reverseEntriesCrudKey: 'reverseEntries',
      revEntriesObj: {
        workstation: getWorkstationNumber(),
        payDate: toShortDate(this.onBussinessChangeDate),
        feeNumber: null,
        feeAmount: 0,
        applyFees: true,
      },
      disableConfirm: false,
    };
  },
  components: {
    CRUDList,
    CRUDDialog,
    ClarionDateControl,
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'TaxRollPaymentsDialog',
    },
    baseCrudKeyOfMainParent: {
      type: String,
      default: 'TaxRollDialog',
    },
    // The host screen's own fee list (TaxrollTransactionFeeList / ownerTransactionFeeList /
    // pickListTaxRecordFeeList). GeneralDetailsForm derives Total Fees and Total Due from THIS
    // list - not from the fee grid - every time it recalculates penalty, so a reversal that
    // refreshes only the grid leaves the new fee ready to be dropped back off the totals.
    baseCrudKeyForFeeList: {
      type: String,
      default: 'baseCrudKeyForFeeList',
    },
    taxDetBaseCrudKey: {
      type: String,
      default: 'taxDetPaymentsRecords',
    },
    taxPayBaseCrudKey: {
      type: String,
      default: 'taxPayPaymentsRecords',
    },
    value: {
      type: Array,
      default: () => [],
    },
    selItem: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item', 'items',
      'selectedTab', 'isVisible',
    ]),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData,
      paymentDialogBusinessDate: (state) => state.tax.taxPayment.paymentDialogBusinessDate || '',
    }),
    editedItem: {
      get() {
        const items = JSON.parse(JSON.stringify(this.value));
        const newVal = items.map((item, index) => ({
          ...item,
          key: `${index}`,
        }));
        return newVal;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    editedItemTwo: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    onBussinessChangeDate: {
      get() {
        return this.paymentDialogBusinessDate;
      },
      set(value) {
        this.setPaymentDialogBusinessDate(value);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'name',
          direction: 'desc',
        },
      ];
    },
    // taxDetailsCount is how many tax records the payment actually paid; the row only carries
    // all of them up to 100 (see taxPayments.util paymentRecordsDestructured). Past that it
    // carries the single detail for the tax record that was searched, so the grid is a slice
    // of the transaction rather than the whole of it.
    isPartialTaxDetailView() {
      const count = (this.editedItemTwo || {}).taxDetailsCount || 0;
      const shown = (this.items(this.taxDetBaseCrudKey) || []).length;
      return count > shown;
    },
  },
  methods: {
    amountFormat,
    toShortDate,
    ...mapMutations('base/crud', [
      'setItem',
      'setItems',
      'setSelectedTab',
      'setIsVisible',
    ]),
    ...mapActions('tax/taxFee', [
      'loadTaxRollFeesTable',
      'taxFeesBasedOnIds',
    ]),
    ...mapActions('tax/taxPayment', [
      'upsertReverseEntirePayment',
      'loadTaxPayments',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setPaymentDialogBusinessDate',
    ]),
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
    dataFromCommonDropDowns(val, whichField) {
      this.revEntriesObj[whichField] = val;
    },
    async onConfirmClicked() {
      this.disableConfirm = true;
      const {
        payDate, workstation, feeNumber, feeAmount, applyFees,
      } = this.revEntriesObj;
      const editedRevEnt = {};
      editedRevEnt._id = this.editedItemTwo._id;
      editedRevEnt.taxInquiryTransaction = this.selItem._id;
      editedRevEnt.taxYear = this.selItem.taxYear;
      editedRevEnt.taxId = this.selItem.taxId;
      editedRevEnt.payDate = payDate ? toIsoDate(payDate) : toIsoDate();
      const wkst = getWorkstationNumber();

      editedRevEnt.workstation = (amountToNumber(workstation || null)
        || amountToNumber(wkst || null));

      // if fee amt is 0, then we dont have to create a fee record
      if ((amountToNumber(feeAmount)) && applyFees) {
        const feeNum = (feeNumber || null) || (this.taxSettingItem.nsfFee || null);
        const filteredTaxMasterList = (this.taxFeeMasterData || [])
          .filter((ft) => ft.feeNumber === feeNum);
        const feeDesc = filteredTaxMasterList.length > 0
          ? filteredTaxMasterList[0].feeDescription : null;
        editedRevEnt.feeAmount = amountToNumber(feeAmount);
        editedRevEnt.feeNumber = feeNum;
        editedRevEnt.feeDescription = feeDesc;
      } else if (!applyFees) {
        delete editedRevEnt.feeAmount;
        delete editedRevEnt.feeNumber;
      }
      delete editedRevEnt.applyFees;
      // just for edge case handling
      if (this.editedItemTwo._id) {
        try {
          await this.upsertReverseEntirePayment({
            item: editedRevEnt,
          });
          // Awaited, not fired and forgotten: the reversal dialog closes onto the tax record
          // behind it, and closing it first would hand the user a form still showing the
          // pre-reversal fee list and totals for as long as the reloads take.
          await this.refreshRecordAfterReversal();
          this.onClose();
          this.setIsVisible([this.reverseEntriesCrudKey, false]);
        } finally {
          // Previously left latched whenever the record had no taxYear/taxId or the mutation
          // rejected, which disabled Confirm for the rest of the session.
          this.disableConfirm = false;
        }
      }
    },
    // Everything on the open record that the reversal just changed, refreshed in place.
    async refreshRecordAfterReversal() {
      const { taxYear, taxId } = this.selItem;
      if (!taxYear || !taxId) return;
      const criteria = { taxYear, taxId };
      await Promise.all([
        // the payments panel - picks up the reversal transaction
        this.loadTaxPayments({ criteria, baseCrudKey: 'GeneralDetailsPayments' }),
        // the fee grid on the record - picks up the NSF fee
        this.loadTaxRollFeesTable({
          criteria,
          baseCrudKey: 'taxRollFeesTable',
          postProcessTrans: this.taxFeesPreProcessTrans,
        }),
        // the host's fee list, which is what the form re-derives Total Fees and Total Due from
        this.refreshFeeListOfMainComponent(),
        // the record itself - Total Fees, Total Due, status codes
        this.updateTheItemOfMainComponent(),
      ]);
    },
    // GeneralDetailsForm.penaltyCaclFunc recomputes totalFee (and from it Total Due) out of
    // feeListBasedInIds whenever the penalty date is touched. Left stale, that recompute
    // silently takes the NSF fee back off a form that was showing it correctly.
    async refreshFeeListOfMainComponent() {
      const { _id } = this.selItem;
      if (!_id) return;
      await this.taxFeesBasedOnIds({
        criteria: { ids: [_id] },
        baseCrudKey: this.baseCrudKeyForFeeList,
        postProcessTrans: taxPostProcessFeesList,
      });
    },
    taxFeesPreProcessTrans(items) {
      const updatedItems = taxFeesPostProcessTrans(items);
      return updatedItems;
    },
    reverseEntriesCliked() {
      const wkst = getWorkstationNumber();
      this.revEntriesObj.payDate = toShortDate(this.onBussinessChangeDate);
      this.revEntriesObj.workstation = amountToNumber(wkst);
      this.revEntriesObj.feeNumber = this.taxSettingItem.nsfFee;
      this.revEntriesObj.feeAmount = this.taxSettingItem.nsfFeeAmount;
      this.revEntriesObj.applyFees = true;
      this.setIsVisible([this.reverseEntriesCrudKey, true]);
    },
    async updateTheItemOfMainComponent() {
      const currentItem = this.item(this.baseCrudKeyOfMainParent);
      const { penaltyDateValue, taxYear, taxId } = currentItem;
      const criteria = { taxYear, taxId };
      const val = await this.loadTaxInquires({
        criteria, postProcessTrans: this.taxPostProcessTrans,
      });
      if (!(val || []).length) return;
      // Merged over the current item rather than replacing it: the host screens decorate the
      // record with display-only fields of their own (status-code highlight colours, and so
      // on) that this narrower reload does not produce.
      const itemData = { ...currentItem, ...val[0], penaltyDateValue };
      this.setItem([this.baseCrudKeyOfMainParent, itemData]);
      this.refreshRowInMainComponentList(itemData);
    },
    // The search grid behind the dialog keeps its own copy of the row, and CRUDList re-seeds
    // the form from that copy on the next click. Without this, the refreshed form reverts to
    // pre-reversal totals the moment the user clicks the record again.
    refreshRowInMainComponentList(itemData) {
      const list = this.items(this.baseCrudKeyOfMainParent) || [];
      const index = list.findIndex((ft) => ft._id === itemData._id);
      if (index === -1) return;
      const updatedList = [...list];
      // Only the amounts the reversal moved - the row keeps everything else the host put on it.
      updatedList.splice(index, 1, {
        ...list[index],
        totalFee: itemData.totalFee,
        totalDue: itemData.totalDue,
        totalPaid: itemData.totalPaid,
        feesAndPen: itemData.feesAndPen,
        penaltyAmount: itemData.penaltyAmount,
        statusCode: itemData.statusCode,
      });
      this.setItems([this.baseCrudKeyOfMainParent, updatedList]);
    },
    taxPostProcessTrans(items) {
      const { penaltyDateValue } = this.item(this.baseCrudKeyOfMainParent);
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const updatedItems = taxCommonPostProcessTrans(items,
        this.todaysDate, this.taxSettingItem, penaltyDateValue, formatPidPositions);
      return updatedItems;
    },
    onApplyFeeCheckBoxClick(val) {
      if (val) {
        this.revEntriesObj.feeNumber = this.taxSettingItem.nsfFee;
        this.revEntriesObj.feeAmount = this.taxSettingItem.nsfFeeAmount;
      } else {
        this.revEntriesObj.feeNumber = null;
        this.revEntriesObj.feeAmount = 0;
      }
    },
    reverseEntriesDisableFunc() {
      // if there if even one taxtype other than 'TAXPAYMENT', disable btn
      // if there is void or pending taxpayment, disable btn
      if ((this.editedItemTwo.taxDetails || []).length) {
        const checkForAnyOtherTaxTypeIsPresOrNot = (this.editedItemTwo.taxDetails || []).filter((ft) => ft.taxType !== 'TAXPAYMENT');
        const checkIfItsAVoidedOrPending = (this.editedItemTwo.taxDetails || []).filter((ft) => ft.taxType === 'TAXPAYMENT' && (ft.void || !ft.posted));
        if (checkForAnyOtherTaxTypeIsPresOrNot.length) return true;
        if (checkIfItsAVoidedOrPending.length) return true;
        return false;
      }
      return true;
    },
    // See TaxFeesTableDialog - the Fee Amount box is readonly rather than disabled on a paid
    // record, so it can still take focus on a click and run these formatters. Skip them there.
    roundAmount() {
      if (this.editedItem.isPaid) return;
      this.revEntriesObj.feeAmount = amountFormat(amountToNumber(this.revEntriesObj.feeAmount));
    },
    amountToNum() {
      if (this.editedItem.isPaid) return;
      this.revEntriesObj.feeAmount = amountToNumber(this.revEntriesObj.feeAmount);
    },
    onClose() {
      this.revEntriesObj.workstation = getWorkstationNumber();
      this.revEntriesObj.payDate = toShortDate(this.onBussinessChangeDate);
      this.revEntriesObj.feeNumber = null;
      this.revEntriesObj.feeAmount = 0;
      this.revEntriesObj.applyFees = true;
    },
  },
};
</script>
